import { z, isoZ } from 'my-zod'

export const commentModel = z.object({
  id: z.string().uuid(),
  topic: z.string(),
  userId: z.number().nullable(),
  profileId: z.number().nullable(),
  content: z.string(),
  pinned: z.boolean(),
  createdDate: isoZ.instant(),
  lastModifiedDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable()
})

export type commentModel = z.infer<typeof commentModel>
